module.exports = __webpack_public_path__ + "static/img/case_tab_07.1ebe36c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_07.png
// module id = XaEV
// module chunks = 34